import Env from '../BsGetEnv'
let domainName
if(Env.isEnVlocal){
    domainName = ''
}else if (Env.isEnvOnline) {
    domainName = 'https://capis.didapinche.com'
} else if (Env.isEnvECS) {
    domainName = 'https://capis-ecs.didapinche.com'
} else {
    domainName = 'https://capis-test.didapinche.com'
}
// hermes平台特殊处理展示xxx数据
if (window.location.host === 'hermes.didachuxing.com') {
    domainName = 'https://capis-ecs.didapinche.com'
}
export default domainName;